import { render } from "./ForgotPassword.vue?vue&type=template&id=17791883"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import exportComponent from "/Users/niq/Documents/Project Apps/TMI/Helpdesk App/apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__